import { css } from '@eti/styles';
import { breakpoints, vars } from '@etg/wings';

const cardStyles = css`
  @media (min-width: ${breakpoints._768}) {
    height: min-content;
    width: 568px;
  }
`;

const flexContentWrapperStyles = css`
  background-color: ${vars.colors.pageBackdrop};
  display: flex;
  height: 100%;
  justify-content: center;
  padding: 8px;
  width: 100%;
`;

export { cardStyles, flexContentWrapperStyles };
